var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "#021317",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 4.93826C8.4 5.63105 8.96363 6.19467 9.65641 6.19467H14V17.2152C14 18.3038 13.1143 19.1895 12.0256 19.1895H1.97436C0.885697 19.1895 0 18.3038 0 17.2152V2.78442C0 1.69576 0.885697 0.810059 1.97436 0.810059H8.4V4.93826ZM5.55405 13.7331H2.94359C2.64622 13.7331 2.40513 13.9742 2.40513 14.2716C2.40513 14.569 2.64622 14.8101 2.94359 14.8101H5.55405C5.85143 14.8101 6.09251 14.569 6.09251 14.2716C6.09251 13.9742 5.85143 13.7331 5.55405 13.7331ZM2.94359 10.8613C2.64622 10.8613 2.40513 11.1024 2.40513 11.3998C2.40513 11.6972 2.64622 11.9383 2.94359 11.9383H10.841C11.1384 11.9383 11.3795 11.6972 11.3795 11.3998C11.3795 11.1024 11.1384 10.8613 10.841 10.8613H2.94359ZM11.3795 8.52801C11.3795 8.23063 11.1384 7.98955 10.841 7.98955H2.94359C2.64622 7.98955 2.40513 8.23063 2.40513 8.52801C2.40513 8.82538 2.64622 9.06647 2.94359 9.06647H10.841C11.1384 9.06647 11.3795 8.82538 11.3795 8.52801ZM9.65642 5.11758C9.55745 5.11758 9.47693 5.03706 9.47693 4.93809H9.47696V1.0332C9.63725 1.11692 9.78687 1.22292 9.9212 1.35L13.3825 4.62463C13.5348 4.76869 13.6615 4.93572 13.76 5.11758H9.65642Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageIcon);
export default __webpack_public_path__ + "static/media/page_icon.52471f10352712f16f0d848ea19cfae1.svg";
export { ForwardRef as ReactComponent };